import {
    ADD_DEPOSIT_HEADER_REQUEST    ,
    ADD_DEPOSIT_HEADER_SUCCESS    ,
    ADD_DEPOSIT_HEADER_ERROR      ,
    GET_ONE_DEPOSIT_HEADER_REQUEST,
    GET_ONE_DEPOSIT_HEADER_SUCCESS,
    GET_ONE_DEPOSIT_HEADER_ERROR  ,
    UPDATE_DEPOSIT_HEADER_REQUEST ,
    UPDATE_DEPOSIT_HEADER_SUCCESS ,
    UPDATE_DEPOSIT_HEADER_ERROR   ,
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case ADD_DEPOSIT_HEADER_REQUEST:
            return {
                loading: true,
            };
        case ADD_DEPOSIT_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case ADD_DEPOSIT_HEADER_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_ONE_DEPOSIT_HEADER_REQUEST:
            return {
                loading: true,
            };
        case GET_ONE_DEPOSIT_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_ONE_DEPOSIT_HEADER_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        case UPDATE_DEPOSIT_HEADER_REQUEST:
            return {
                loading: true,
            };
        case UPDATE_DEPOSIT_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                payloadUpdate: [payload],
            };
        case UPDATE_DEPOSIT_HEADER_ERROR:
            return {
                ...state,
                loading: false,
                payloadUpdate: [payload],
            };

        default:
            return state;
    }
}
